import React from "react";
import "./OrderTotal.scss";

const OrderTotal = ({ frequency, total }) => {
  return (
    <>
      {total ? (
        <div className="order-total">
          <div className="order-total__label">Total</div>
          <div className="order-total__value">
            {frequency === "monthly" ? total + "/mo" : total}
          </div>
        </div>
      ) : (
        <div className="order-total is-empty"></div>
      )}
    </>
  );
};

export default OrderTotal;
